/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { memo } from 'react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { EmojiPreviewComponent } from '../common/EmojiPreviewComponent'; // ED-26865: use compiled EmojiPreviewComponent when migrating picker to compiled css
import { emojiPickerFooter, emojiPickerFooterWithTopShadow } from './styles';
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
var previewFooterClassnames = [emojiPickerFooter, emojiPickerFooterWithTopShadow];
export var emojiPickerFooterTestId = 'emoji-picker-footer';
var EmojiPickerFooter = function EmojiPickerFooter(_ref) {
  var selectedEmoji = _ref.selectedEmoji;
  return jsx("div", {
    css: previewFooterClassnames,
    "data-testid": emojiPickerFooterTestId
  }, selectedEmoji && jsx(EmojiPreviewComponent, {
    emoji: selectedEmoji
  }));
};
export default /*#__PURE__*/memo(EmojiPickerFooter);